module.exports = __webpack_public_path__ + "static/img/img_content04.5860983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main/pc/img_content04.png
// module id = FBRF
// module chunks = 10